export const TRANSFER_LAST_DOCUMENT_SAVE = "TRANSFER_LAST_DOCUMENT_SAVE";
